import { render, staticRenderFns } from "./DeleteCustomCampaignModal.vue?vue&type=template&id=5d910420&scoped=true"
import script from "./DeleteCustomCampaignModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCustomCampaignModal.vue?vue&type=style&index=0&id=5d910420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d910420",
  null
  
)

export default component.exports